import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import lottoService from '../../services/lotto/lottoService';
import './LottoLatestExtraction.css';

/**
 * Component to display latest Lotto extraction
 */
const LottoLatestExtraction = ({ selectedWheel }) => {
  const { t } = useTranslation();
  const [extraction, setExtraction] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (selectedWheel) {
      loadLatestExtraction();
    }
  }, [selectedWheel]);

  const loadLatestExtraction = async () => {
    try {
      setLoading(true);
      const data = await lottoService.getLatestExtractions(selectedWheel.code, 1);
      if (data.length > 0) {
        setExtraction(data[0]);
      }
      setError(null);
    } catch (err) {
      setError(err.message);
      console.error('Error loading extraction:', err);
    } finally {
      setLoading(false);
    }
  };

  if (!selectedWheel) {
    return (
      <div className="alert alert-info">
        {t('selectWheelFirst') || 'Please select a wheel'}
      </div>
    );
  }

  if (loading) {
    return (
      <div className="alert alert-info">
        <div className="spinner-border spinner-border-sm me-2" role="status">
          <span className="visually-hidden">{t('loading')}</span>
        </div>
        {t('loading')}...
      </div>
    );
  }

  if (error) {
    return (
      <div className="alert alert-danger">
        <strong>{t('error')}:</strong> {error}
      </div>
    );
  }

  if (!extraction) {
    return (
      <div className="alert alert-info">
        {t('noExtrationsAvailable') || 'No extractions available'}
      </div>
    );
  }

  return (
    <div className="card card-last-extraction">
      <div className="card-body">
        <h5 className="card-title">
          <i className="icon-last">🎰</i> {t('lastExtractedCombination') || 'Ultima Estrazione Estratta'} - {selectedWheel.name}
        </h5>
        <div className="last-extraction-content">
          <div className="combination-display">
            {extraction.numbers.map((num, idx) => (
              <div key={idx} className="combination-number number-last">
                {num}
              </div>
            ))}
          </div>
          <div className="last-extraction-info">
            <div className="info-item">
              <span className="info-label">{t('date') || 'Data'}:</span>
              <span className="info-value">{extraction.extractionDate}</span>
            </div>
            {extraction.totalWinners && (
              <div className="info-item">
                <span className="info-label">{t('winners') || 'Vincitori'}:</span>
                <span className="info-value">{extraction.totalWinners}</span>
              </div>
            )}
            {extraction.totalAmount && (
              <div className="info-item">
                <span className="info-label">{t('totalPrize') || 'Premio'}:</span>
                <span className="info-value">€{extraction.totalAmount?.toLocaleString('it-IT')}</span>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default LottoLatestExtraction;
